// src/components/Alerts.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
    Container,
    Typography,
    Box,
    Paper,
    Grid,
    TextField,
    Button,
    MenuItem,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    IconButton
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from 'react-router-dom';

const Alerts = () => {
    const API_URL = process.env.REACT_APP_API_URL || '';
    const [alerts, setAlerts] = useState([]);
    const [form, setForm] = useState({
        alert_type: '',
        service_type: '',
        severity: '',
        message: '',
        status: ''
    });
    const token = localStorage.getItem('token');
    const navigate = useNavigate();

    const fetchAlerts = async () => {
        try {
            const response = await axios.get(`${API_URL}/api/alerts`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setAlerts(response.data);
        } catch (error) {
            console.error('Error fetching alerts:', error);
        }
    };

    useEffect(() => {
        fetchAlerts();
    }, [token]);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            // Dodanie nowego alertu
            await axios.post(`${API_URL}/api/alerts`, form, {
                headers: { Authorization: `Bearer ${token}` }
            });
            fetchAlerts(); // odśwież listę
            setForm({
                alert_type: '',
                service_type: '',
                severity: '',
                message: '',
                status: ''
            });
        } catch (error) {
            console.error('Error adding alert:', error);
        }
    };

    return (
        <Container maxWidth="lg">
            <Box sx={{ mt: 4 }}>
                <Typography variant="h4" gutterBottom>Alerty</Typography>
                {/* Formularz dodawania alertu */}
                <Paper sx={{ p: 2, mb: 4 }}>
                    <Typography variant="h6" gutterBottom>Dodaj nowy alert</Typography>
                    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    select
                                    fullWidth
                                    label="Typ alertu"
                                    name="alert_type"
                                    value={form.alert_type}
                                    onChange={handleChange}
                                    required
                                >
                                    <MenuItem value="system">system</MenuItem>
                                    <MenuItem value="notification">notification</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    select
                                    fullWidth
                                    label="Typ usługi"
                                    name="service_type"
                                    value={form.service_type}
                                    onChange={handleChange}
                                    required
                                >
                                    <MenuItem value="aiteams">aiteams</MenuItem>
                                    <MenuItem value="pricemonit">pricemonit</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    select
                                    fullWidth
                                    label="Ważność"
                                    name="severity"
                                    value={form.severity}
                                    onChange={handleChange}
                                    required
                                >
                                    <MenuItem value="low">low</MenuItem>
                                    <MenuItem value="medium">medium</MenuItem>
                                    <MenuItem value="high">high</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    select
                                    fullWidth
                                    label="Status"
                                    name="status"
                                    value={form.status}
                                    onChange={handleChange}
                                    required
                                >
                                    <MenuItem value="new">new</MenuItem>
                                    <MenuItem value="read">read</MenuItem>
                                    <MenuItem value="resolved">resolved</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    label="Wiadomość"
                                    name="message"
                                    value={form.message}
                                    onChange={handleChange}
                                    multiline
                                    rows={4}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Button type="submit" variant="contained" color="primary">
                                    Dodaj alert
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
                </Paper>

                {/* Tabela z listą alertów */}
                <Paper sx={{ p: 2, width: '100%', overflowX: 'auto' }}>
                    <Box sx={{ minWidth: 800 }}>
                        <Typography variant="h6" gutterBottom>Lista alertów</Typography>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>ID</TableCell>
                                    <TableCell>Typ alertu</TableCell>
                                    <TableCell>Typ usługi</TableCell>
                                    <TableCell>Ważność</TableCell>
                                    <TableCell>Wiadomość</TableCell>
                                    <TableCell>Status</TableCell>
                                    <TableCell>Utworzony</TableCell>
                                    <TableCell>Akcje</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {alerts.map(alert => (
                                    <TableRow key={alert.id} style={{ color: alert.severity === 'high' ? '#fff' : 'black' }} bgcolor={alert.severity === 'high' ? '#ffdddd' : ''} fontColor={alert.severity === 'high' ? '#fff' : 'black'} borderRadius={2}>
                                        <TableCell>{alert.id}</TableCell>
                                        <TableCell>{alert.alert_type}</TableCell>
                                        <TableCell>{alert.service_type}</TableCell>
                                        <TableCell>{alert.severity}</TableCell>
                                        <TableCell>{alert.message}</TableCell>
                                        <TableCell>{alert.status}</TableCell>
                                        <TableCell>{new Date(alert.created_at).toLocaleString()}</TableCell>
                                        <TableCell>
                                            <IconButton color="primary" onClick={() => navigate(`/alerts/edit/${alert.id}`)}>
                                                <EditIcon />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Box>
                </Paper>
            </Box>
        </Container>
    );
};

export default Alerts;